import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 發送簡訊驗證碼
 */
const VerifySmsCode = [
    'POST',
    RouteUrlList.API_VerifySmsCode.path,
    {},
    200,
    {
        status: true,
        title: '資料載入成功',
        message: '取得成功',
        errorCode: '',
        isReachedVerifyMaxTry: false
    }
];
export default VerifySmsCode;
